import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import EventsPage from "@/pages/Events";
import GalleryPage from "@/pages/Gallery";
import AmbassadorsPage from "@/pages/Ambassadors";
import ContactPage from "@/pages/Contact";
import AboutPage from "@/pages/About";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/ambassadors" element={<AmbassadorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0c0c0e",
                border: "1px solid rgba(168,85,247,0.3)",
                color: "white",
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
